import ProjectMemberApi from './rest/ProjectMemberApi';

export default new ProjectMemberApi();
